export const SET_THEMATICS_LIST = "SET_THEMATICS_LIST";
export const SET_THEMATICS_FAILED = "SET_THEMATICS_FAILED";

export const RETRIEVE_THEMATIC_ARTICLE_LIST_START = 'RETRIEVE_THEMATIC_ARTICLES_START';
export const RETRIEVE_THEMATIC_ARTICLE_LIST_SUCCESS = 'RETRIEVE_THEMATIC_ARTICLES_SUCCESS';
export const RETRIEVE_THEMATIC_ARTICLE_LIST_FAIL = 'RETRIEVE_THEMATIC_ARTICLES_FAIL';


// WEBPACK FOOTER //
// ./src/components/Thematics/thematicsActionTypes.js